export default [
    {
        path: '/service',
        name: 'service',

        component: () => import('@/views/setting/ServiceView.vue'),
        meta: {
          requiresAuth: true,
          requiresAdminOrSuperAdmin: true,
          pageTitle: 'Service',
          breadcrumb: [
            {
              text: 'Service',
              active: false,
            },
          ],
        },
      },
      {
        path: '/section',
        name: 'section',
        component: () => import('@/views/evaluation/section/SectionView.vue'),
        meta: {
          requiresAuth: true,
          requiresAdminOrSuperAdmin: true,
          pageTitle: 'Section',
          breadcrumb: [
            {
              text: 'Section',
              active: true,
            },
          ],
        },
      },
      {
        path: '/section/content-section/:id',
        name: 'content-section',
        component: () => import('@/views/evaluation/section/ContentSectionView.vue'),
        meta: {
          requiresAuth: true,
          requiresAdminOrSuperAdmin: true,
          pageTitle: 'Section',
          breadcrumb: [
            {
              text: 'Question',
              active: false,
            },
          ],
        },
      },
      {
        path: '/direction_cellule',
        name: 'direction_cellule',
        component: () => import('@/views/setting/DirectionView.vue'),
        meta: {
          requiresAuth: true,
          requiresAdminOrSuperAdmin: true,
          pageTitle: 'Direction - Cellule',
          breadcrumb: [
            {
              text: 'Direction - Cellule',
              active: true,
            },
          ],
        },
      },
      {
        path: '/peage',
        name: 'peage',
        component: () => import('@/views/setting/TollView.vue'),
        meta: {
          requiresAuth: true,
          requiresAdminOrSuperAdmin: true,
          pageTitle: 'Péage',
          breadcrumb: [
            {
              text: 'Péage',
              active: true,
            },
          ],
        },
      },
      {
        path: '/setting',
        name: 'setting',
        meta: { requiresAuth: true,
          requiresAdminOrSuperAdmin: true, },  // Nécessite une authentification
        component: () => import('@/views/setting/SettingView.vue'),
      
      },
      {
        path: '/reminder_blocklist',
        name: 'reminder_blocklist', 
        meta: { requiresAuth: true,
          requiresAdminOrSuperAdmin: true, },  // Nécessite une authentification
        component: () => import('@/views/setting/ReminderBlocklistView.vue'),
      },
]